var _rect, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInst = function SvgInst(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#4853EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 8H10.3438C9.05151 8 8 9.05151 8 10.3438V21.6562C8 22.9485 9.05151 24 10.3438 24H21.6562C22.9485 24 24 22.9485 24 21.6562V10.3438C24 9.05151 22.9485 8 21.6562 8ZM16.0312 20.1875C13.705 20.1875 11.8125 18.295 11.8125 15.9688C11.8125 13.6425 13.705 11.75 16.0312 11.75C18.3575 11.75 20.25 13.6425 20.25 15.9688C20.25 18.295 18.3575 20.1875 16.0312 20.1875ZM20.7188 12.6875C19.9434 12.6875 19.3125 12.0566 19.3125 11.2812C19.3125 10.5059 19.9434 9.875 20.7188 9.875C21.4941 9.875 22.125 10.5059 22.125 11.2812C22.125 12.0566 21.4941 12.6875 20.7188 12.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C14.346 13 13 14.346 13 16C13 17.654 14.346 19 16 19C17.654 19 19 17.654 19 16C19 14.346 17.654 13 16 13Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cc0bdc20927205b978e9d6cdeeae54c9.inst.cc0bdc20927205b978e9d6cdeeae54c9.svg";
export { ForwardRef as ReactComponent };